module.exports = __webpack_public_path__ + "img/event-voices.fb0812ce.jpg";